import { Text, View } from "react-native";
import TableList from "app/components/organisms/TableList";
import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { ProfileAvatar } from "app/components/atoms/ProfileAvatar";
import CardItem from "app/components/organisms/CardItem";
import { UserListContent } from "../../userRoles/users/organism/UserListContent";
import { ColumnModel } from "app/services/api/types/common/models/ColumnModel";
import { useLocation } from "../provider/LocationProvider";

interface LocationUsersListProps {
  locationId: number;
}

export default function LocationUsersList() {
  const { location, isLoading } = useLocation();

  const columns: ColumnModel<AuthUserModel>[] = [
    {
      title: "Name",
      dataKey: "first_name",
      renderCell: (user: AuthUserModel) => (
        <View className="flex flex-row items-center">
          <ProfileAvatar user={user} />
        </View>
      ),
      colSpan: 5,
    },
    {
      title: "Role",
      dataKey: "roles",
      renderCell: (user: AuthUserModel) => (
        <Text className="text-xs text-typography-600 text-left">
          {user?.roles?.length
            ? user.roles.map((role) => role.display_name).join(", ")
            : "Role(s) unavailable"}
        </Text>
      ),
      colSpan: 2,
    },
    {
      title: "Location(s)",
      dataKey: "locations",
      renderCell: (user: AuthUserModel) => (
        <View className="flex flex-col">
          <Text className="text-xs text-typography-600 text-left">
            {user?.locations?.length
              ? user.locations.map((location) => location.name).join(", ")
              : "Location(s) unavailable"}
          </Text>
        </View>
      ),
      colSpan: 3,
    },
  ];

  return (
    <View className="flex-1">
      <TableList
        columns={columns}
        data={location?.users ?? []}
        isFetching={isLoading}
        emptyMessage="No users available for this location."
        mobileRenderItem={(item) => (
          <CardItem
            key={item.id}
            cardContent={<UserListContent user={item} />}
          />
        )}
      />
    </View>
  );
}
